/**
 * Enum for Product Literal IDs.
 */
export enum ProductLiteralIds {
  portfolio = 'portfolio',
  ddi = 'ddi'
}
